module.exports = __webpack_public_path__ + "static/media/arrow-left-blue.f0406510.svg";